define(['exports', 'react', 'lodash', '../../i18n', '../../assets/github.svg', '../../assets/stack-overflow.svg'], function (exports, _react, _lodash, _i18n, _github, _stackOverflow) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _github2 = _interopRequireDefault(_github);

  var _stackOverflow2 = _interopRequireDefault(_stackOverflow);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var GithubProfileView = function (_Component) {
    _inherits(GithubProfileView, _Component);

    function GithubProfileView() {
      _classCallCheck(this, GithubProfileView);

      return _possibleConstructorReturn(this, (GithubProfileView.__proto__ || Object.getPrototypeOf(GithubProfileView)).apply(this, arguments));
    }

    _createClass(GithubProfileView, [{
      key: 'renderGithubIcon',
      value: function renderGithubIcon(profile) {

        return _react2.default.createElement(
          'div',
          { className: 'clickable mr2', onClick: function onClick() {
              return profile.url ? window.open(profile.url) : null;
            } },
          profile.avatarUrl ? _react2.default.createElement('img', { src: profile.avatarUrl, height: '75' }) : _react2.default.createElement(_github2.default, { className: 'svg-icon svg-5x' })
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var profile = this.props.profile;


        var nullLabel = '-';

        return _react2.default.createElement(
          'div',
          { className: 'mx2 mt2 flex items-center' },
          _react2.default.createElement(
            'div',
            null,
            this.renderGithubIcon(profile)
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'bold sub-heading mr3' },
              _i18n2.default.t('dk-ui-lib.candidates.socials.github')
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt2 flex justify-center items-center' },
              _react2.default.createElement(
                'div',
                { className: 'mr1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.followers')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 bold black' },
                  profile ? profile.followers : nullLabel
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.stars')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 bold black' },
                  profile ? profile.stars : nullLabel
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.forks')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 bold black' },
                  profile ? profile.forks : nullLabel
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.repos')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 bold black' },
                  profile ? profile.repositories : nullLabel
                )
              )
            )
          )
        );
      }
    }]);

    return GithubProfileView;
  }(_react.Component);

  var StackOverflowProfileView = function (_Component2) {
    _inherits(StackOverflowProfileView, _Component2);

    function StackOverflowProfileView() {
      _classCallCheck(this, StackOverflowProfileView);

      return _possibleConstructorReturn(this, (StackOverflowProfileView.__proto__ || Object.getPrototypeOf(StackOverflowProfileView)).apply(this, arguments));
    }

    _createClass(StackOverflowProfileView, [{
      key: 'renderStackOverFlowIcon',
      value: function renderStackOverFlowIcon(profile) {

        return _react2.default.createElement(
          'div',
          { className: 'clickable mr2', onClick: function onClick() {
              return profile.url ? window.open(profile.url) : null;
            } },
          profile.avatarUrl ? _react2.default.createElement('img', { src: profile.avatarUrl, height: '75' }) : _react2.default.createElement(_stackOverflow2.default, { className: 'svg-icon svg-5x' })
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var profile = this.props.profile;


        var nullLabel = '-';

        return _react2.default.createElement(
          'div',
          { className: 'mx2 mt2 flex items-center' },
          _react2.default.createElement(
            'div',
            null,
            this.renderStackOverFlowIcon(profile)
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'bold sub-heading mr3' },
              _i18n2.default.t('dk-ui-lib.candidates.socials.stackoverflow')
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt2 flex justify-center items-center' },
              _react2.default.createElement(
                'div',
                { className: 'mr1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.reputation')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 black bold' },
                  profile ? profile.reputation : nullLabel
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.questions')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 black bold' },
                  profile ? profile.questionsCount : nullLabel
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  null,
                  _i18n2.default.t('dk-ui-lib.candidates.socials.answers')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt1 black bold' },
                  profile ? profile.answersCount : nullLabel
                )
              ),
              _react2.default.createElement('div', { className: 'border-right mx1 vertical-border-color self-stretch' }),
              _react2.default.createElement(
                'div',
                { className: 'mx1' },
                _react2.default.createElement(
                  'div',
                  { className: 'flex items-center' },
                  _react2.default.createElement(
                    'div',
                    { className: 'mr1' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _i18n2.default.t('dk-ui-lib.candidates.socials.gold')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'mt1 black bold' },
                      profile && profile.badges ? profile.badges.gold : nullLabel
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mx1' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _i18n2.default.t('dk-ui-lib.candidates.socials.silver')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'mt1 black bold' },
                      profile && profile.badges ? profile.badges.silver : nullLabel
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mx1' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _i18n2.default.t('dk-ui-lib.candidates.socials.bronze')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'mt1 black bold' },
                      profile && profile.badges ? profile.badges.bronze : nullLabel
                    )
                  )
                )
              )
            )
          )
        );
      }
    }]);

    return StackOverflowProfileView;
  }(_react.Component);

  var SocialProfiles = function (_Component3) {
    _inherits(SocialProfiles, _Component3);

    function SocialProfiles() {
      _classCallCheck(this, SocialProfiles);

      return _possibleConstructorReturn(this, (SocialProfiles.__proto__ || Object.getPrototypeOf(SocialProfiles)).apply(this, arguments));
    }

    _createClass(SocialProfiles, [{
      key: 'render',
      value: function render() {
        var _props$socialProfiles = this.props.socialProfiles,
            github = _props$socialProfiles.github,
            stackoverflow = _props$socialProfiles.stackoverflow;

        var shouldRenderGithubProfile = !_lodash2.default.isEmpty(github);
        var shouldRenderStackoverflowProfile = !_lodash2.default.isEmpty(stackoverflow);
        return _react2.default.createElement(
          'div',
          { className: 'mx4 mt2 py3 px4 white-background' },
          _react2.default.createElement(
            'div',
            { className: 'main-heading' },
            _i18n2.default.t('dk-ui-lib.candidates.socials.social_profiles')
          ),
          shouldRenderGithubProfile && _react2.default.createElement(GithubProfileView, { profile: github }),
          shouldRenderStackoverflowProfile && _react2.default.createElement(StackOverflowProfileView, { profile: stackoverflow })
        );
      }
    }]);

    return SocialProfiles;
  }(_react.Component);

  exports.default = SocialProfiles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/SocialProfiles.js
// module id = 1206
// module chunks = 0